import React, { useState } from 'react';
import { X, Download, CheckCircle2 } from 'lucide-react';
import { saveNewsletterSignup } from '../mock';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

const NewsletterSignup = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 800));
    
    saveNewsletterSignup(formData.email, formData.name);
    setIsSubmitted(true);
    setIsLoading(false);
    
    setTimeout(() => {
      onClose();
      setIsSubmitted(false);
      setFormData({ name: '', email: '' });
    }, 3000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full relative overflow-hidden">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
          aria-label="Close"
        >
          <X size={24} />
        </button>

        {!isSubmitted ? (
          <div className="p-8">
            <div className="flex items-center justify-center w-16 h-16 bg-blue-50 rounded-full mb-6">
              <Download className="text-blue-600" size={28} />
            </div>
            
            <h2 className="text-2xl font-normal text-gray-900 mb-2">
              Get Your Free Aurora Guide
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Download the <strong>Aurora Readiness Guide</strong> — practical tips for planning your Northern Lights adventure, including best times, what to pack, and photography basics.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="name" className="text-sm text-gray-700 mb-1">
                  First Name
                </Label>
                <Input
                  id="name"
                  type="text"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full"
                />
              </div>
              
              <div>
                <Label htmlFor="email" className="text-sm text-gray-700 mb-1">
                  Email Address
                </Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="your@email.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full"
                />
              </div>

              <Button
                type="submit"
                disabled={isLoading}
                className="w-full bg-gray-900 text-white hover:bg-gray-800 transition-colors"
              >
                {isLoading ? 'Sending...' : 'Get the Free Guide'}
              </Button>
            </form>

            <p className="text-xs text-gray-500 mt-4 text-center">
              Join our community of light chasers. Unsubscribe anytime.
            </p>
          </div>
        ) : (
          <div className="p-8 text-center">
            <div className="flex items-center justify-center w-16 h-16 bg-green-50 rounded-full mb-6 mx-auto">
              <CheckCircle2 className="text-green-600" size={32} />
            </div>
            <h2 className="text-2xl font-normal text-gray-900 mb-2">
              Welcome to the Journey!
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Check your email for the <strong>Aurora Readiness Guide</strong> and our welcome message.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsletterSignup;